import { OnboardingContextProvider } from './context/OnboardingContext';
import OnboardingPageSelector from './components/OnboardingPageSelector';
import OnboardingHeader from './components/OnboardingHeader';

export default function OnboardingFlow() {
	return (
		<OnboardingContextProvider>
			<div className="relative flex h-screen w-full flex-col gap-4 overflow-auto pt-4 lg:pl-4">
				<OnboardingHeader />
				<OnboardingPageSelector />
			</div>
		</OnboardingContextProvider>
	);
}
